import { useRef, useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useMutation, useQueryClient } from "react-query";
import AxiosT from "../../../setup/setup-axios-bearer";
import { Box, Button, TextField } from "@mui/material";
import { Add, Close, SettingsInputAntennaTwoTone } from "@material-ui/icons";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  addBarcode: {
    padding: "0 24px",
    transform: "translateY(32px)",
    position: "relative",
    [theme.breakpoints.down("360")]: {
      padding: "0 14px",
    },
    "& Button": {
      position: "absolute",
      top: "10px",
      left: "20px",
      padding: "6px",
      minWidth: "42px",
      [theme.breakpoints.down("360")]: {
        left: "8px",
      },
    },
    "& input": {
      height: "0.6em",
      padding: "22px 14px 22px 0",
      fontSize: "0.875rem",
      width: "100%",
      borderRadius: "21px",
      outline: "0",
      border: "1px solid rgb(113,113,113)",
      "&:focus": {
        boxShadow: "0 0 0 0.25rem rgb(13 ,110 ,253 , 25%)",
        borderColor: "#86b7fe",
      },
    },
  },
  clear: {
    position: "absolute",
    top: 16,
    left: 64,
    color: "#999",
    cursor: "pointer",
  },
}));

const AddBarcode = ({ factorID, productID }) => {
  const classes = useStyles();
  const [readOnly, setReadOnly] = useState();
  const myRef = useRef();

  const [barcode, setBarcode] = useState();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (myRef && myRef.current) {
      const input = myRef.current;
      input.focus();
    }
  });

  const { data, isLoading, mutate, error } = useMutation(
    ({ barcode, id, pd_id }) =>
      AxiosT.get(
        `/add-into-warehouse?id=${factorID}&pd_id=${productID}&barcode=${barcode}`,
        {
          barcode,
          id,
          pd_id,
        }
      ),
    {
      onSuccess: (data) => {
        queryClient.resetQueries(["getBarcodeList"]);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!barcode) {
      toast.info("لطفا شماره بارکد را وارد نمایید");
    } else {
      mutate({
        barcode: barcode,
        id: factorID,
        pd_id: productID,
      });
      setBarcode("");
    }
  };

  const handleClear = () => {
    setBarcode("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box className={classes.addBarcode}>
        <input
          type="text"
          name="barcode"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          ref={myRef}
          placeholder="کد کالا"
          onBlur={() => setReadOnly(false)}
        />
        <Button variant="contained" startIcon={<Add />} type="submit"></Button>
        <Box className={classes.clear} onClick={handleClear}>
          <Close fontSize="small" />
        </Box>
      </Box>
    </form>
  );
};
export default AddBarcode;
